import { TZDate } from "@date-fns/tz";
import { RunSummary } from "@shared/lib/database/query.types.js";
import { format } from "date-fns";

export default function (run: RunSummary, timezone: string) {
  const startDate = new TZDate(run.start_at, timezone);
  const endDate = run.end_at ? new TZDate(run.end_at, timezone) : null;

  if (!endDate) return formatTime(startDate);

  return [formatTime(startDate), formatTime(endDate)].join(" – ");
}

function formatTime (date: Date) {
  return format(date, date.getMinutes() > 0 ? "h:mmaaa" : "haaa");
}
